export default __webpack_public_path__ + "0c932b78b6f3a656ef280e3faf62f463.png";